import { Component, Input } from '@angular/core';

export type ScoreRingSize = 'sm' | 'lg';

/**
 * PLAN-Pitts-Salud-Flota-FRONT.md §8/§6.3 — anillo de score 0-100 con color
 * por umbral, en dos tamaños (pantallas 1 y 2). No existía nada parecido en
 * el repo (lo más cercano era p-rating de estrellas dentro de card-info).
 *
 * Umbrales alineados con VehicleHealthService.labelForScore /
 * CorporateFleetHealthService.labelForFleetScore en pitts-api: ≥70 bien,
 * 40-69 necesita atención, <40 urgente — mismo corte, mismo color, en las
 * dos superficies (conductor y flota).
 */
@Component({
  selector: 'app-score-ring',
  standalone: false,
  templateUrl: './score-ring.component.html',
  styleUrl: './score-ring.component.scss',
})
export class ScoreRingComponent {
  @Input() score = 0;
  @Input() size: ScoreRingSize = 'lg';
  @Input() label?: string;

  private readonly radius = 45;
  readonly circumference = 2 * Math.PI * this.radius;

  get clampedScore(): number {
    return Math.max(0, Math.min(100, this.score));
  }

  get dashOffset(): number {
    return this.circumference * (1 - this.clampedScore / 100);
  }

  get colorClass(): 'good' | 'warn' | 'critical' {
    if (this.clampedScore >= 70) return 'good';
    if (this.clampedScore >= 40) return 'warn';
    return 'critical';
  }
}
